<template>
  <v-container class="auth-page">
    <v-layout row>
      <v-flex class="my-5">
        <H1>
          Login
        </H1>
        <auth-form></auth-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.auth-page {
  display: inherit;
}
</style>

<script>
import authForm from '@/components/authForm.vue'

export default {
  name: 'authPage',
  components: {
    authForm
  },
  metaInfo: {
    meta: [
      { vmid: 'description', name: 'description', content: 'bar' }
    ]
  },
  data () {
    return {
    }
  }
}
</script>
